// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision.broadphase

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Filter class for broadphase layers
 *
 * C++ `JPH::BroadPhaseLayerFilter`.
 */
open class BroadPhaseLayerFilter internal constructor(internal val broadPhaseLayerFilterHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    /** Creates one whose functions a subclass overrides. */
    constructor() : this(JphBroadPhaseLayerFilter_createUpcalls(Upcalls.function), owned = true) {
        if (this::class != BroadPhaseLayerFilter::class) JphBroadPhaseLayerFilter_bindUpcalls(broadPhaseLayerFilterHandle, Upcalls.reference(this))
    }

    override fun close() =
        closeOnce { JphBroadPhaseLayerFilter_destroy(broadPhaseLayerFilterHandle) }

    /** Function to filter out broadphase layers when doing collision query test (return true to allow testing against objects with this layer) */
    open fun shouldCollide(layer: BroadPhaseLayer): Boolean =
        JphBroadPhaseLayerFilter_ShouldCollide(broadPhaseLayerFilterHandle, layer.value)

    override fun nativeUpcall(method: Int, args: NativePointer, result: NativePointer): Boolean {
        when (method) {
            0 -> writeSlot(result, if (shouldCollide(BroadPhaseLayer(readSlot(args, 0).toInt()))) 1L else 0L)
            else -> return false
        }
        return true
    }
}
